module.exports = __webpack_public_path__ + "media/src/assets/images/guests-4812d692d9eeced972ae866a0395bafd.svg";